export const locales = {
    'sr': 'sr-Latn',
    'en': 'en-US',
}
